// ERP Attribute Engine — Config Loader
import { ROLE_PERMISSIONS } from '../config/roles';
import { API_BASE as API_URL, getToken} from '../../../lib/api';

const cache = new Map();

export async function loadConfig(solutionId, role) {
  const cacheKey = `${solutionId}:${role}`;
  if (cache.has(cacheKey)) return cache.get(cacheKey);

  const token = getToken();
  const response = await fetch(`${API_URL}/api/attribute-engine/config/${solutionId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const result = await response.json();

  if (!result.success) {
    throw new Error(result.error || `Failed to load configuration for ${solutionId}`);
  }

  const { solution, layout, groups: groupList, attributes: attrList } = result.data;

  const attributes = new Map();
  attrList.forEach(attr => {
    const override = solution.overrides?.[attr.id];
    attributes.set(attr.id, override ? { ...attr, ...override } : attr);
  });

  const groups = new Map();
  groupList.forEach(g => groups.set(g.id, g));

  const rolePermission =
    ROLE_PERMISSIONS.find(r => r.role === role) ||
    ROLE_PERMISSIONS.find(r => r.role === 'Viewer');

  const resolved = { solution, layout, attributes, groups, rolePermission };
  cache.set(cacheKey, resolved);
  return resolved;
}

export function clearConfigCache() {
  cache.clear();
}

export async function getAvailableSolutions() {
  try {
    const token = getToken();
    const res = await fetch(`${API_URL}/api/attribute-engine/config/solutions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const json = await res.json();
    if (json.success) return json.data;
  } catch (err) {
    console.error('Failed to fetch solutions:', err);
  }
  return [];
}
